module.exports = __webpack_public_path__ + "static/media/trending_active.6f120185.svg";